import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {ITheCryptGameData, ITheCryptInitData} from "./ITheCryptData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {TheCrypt} from "../TheCrypt";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ISymbolData} from "../symbols/TheCryptSymbol";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {TheCryptGameConfig} from "../TheCryptGameConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheCryptWinConfig} from "../configs/TheCryptWinConfig";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";

export class TheCryptModel extends GameModel<ITheCryptInitData, ITheCryptGameData> {

    private _isRestore: boolean;
    private _isRestoreFeatureBet: boolean;
    private _isBigWin: boolean;
    public currentWinRatio: number;
    private _buyFeatureName: string;
    private _prevTotalWinBigWin: number;
    public prevBigWinLevel: number;
    public freespinsLeft: number;
    public freespinTriggeredThisSpin: boolean;
    public reels: string[][];
    public reelsData: ISymbolData[][];
    public reelsFillUpData: ISymbolData[][];
    public mode: string;
    public nextMode: string;
    public wasFeatureBuy: boolean;
    public hasNoAvalancheWin: boolean;
    public gameAreaSize: number[];
    public afterRevealGameAreaSize: number[];

    public evaluatedArea: string[][];

    public mysterySymbolPositions: number[];
    public mysterySymbolPotentialWin: number[][][];
    public mysterySymbolSize: number[];
    public mysterySymbolRevealed: string;
    public brokeTheBank: boolean;

    public symbolPositionYs: number[][];
    public symbolPositionYsAfterReveal: number[][];
    public wildOnReel: boolean[];
    public maxWinReelId: number;
    public xNudgeMultiplier: number[];

    //M1,M2,M3,M4,M5,M6
    public sideBarProgress: number[];
    public hasMeterUpgrade: boolean;
    public wildMSymbols: string[];
    public nextWildMSymbols: string[];
    public patchWildPositions: boolean[][];
    public M1MultiplierPositions: boolean[][];
    public m1CurrentMultiplier: number;

    public allWinPositions: boolean[][];
    public allWinPositionSymbols: string[][];
    public avalancheRoundWin: number;
    public accumulatedRoundWin: number;
    public winRatio: number;
    public avalancheWinRatio: number;
    public winData: IBetWayWinData[];
    public isWin: boolean;
    public boostedBet: boolean;

    public nearWinReels: boolean[];
    public numberOfScattersOnReel: number[];
    public numberOfScattersOnReelPrev: number[];

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data: boolean) => {
            this._isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data: string) => {
            this._buyFeatureName = data;
        });
        TheCrypt.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            if (betData.type === APIBetType.FEATURE_BET && betData.featureName !== TheCrypt.boostedName) {

            }
            for (let index = 0; index < TheCrypt.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCrypt.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this._buyFeatureName);
                    break;
                }
            }
        });

        TheCrypt.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            if (betData.type === APIBetType.FEATURE_BET && betData.featureName !== TheCrypt.boostedName) {

            }
            for (let index = 0; index < TheCrypt.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCrypt.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this._buyFeatureName);
                    break;
                }
            }
        });
    }

    private checkXNudgeMultiplier(clientData: number[], serverData: number[], reels: string[][]): void {
        let c: number[] = clientData.concat(), s: number[] = serverData.concat();
        if (c.length != s.length) {
            debugger;
        }
        s.forEach((multiplier: number, i: number) => {
            if (multiplier != c[i]) {
                if (reels[i].join() != ['Y', 'Y', 'W', 'W', 'W', 'W'].join()) {
                    Logger.logDev(`xNudge multiplier ${c} is not same from server: ${s}`)
                }
            }
        });
    }

    private checkXWayRevealedSymbol(clientData: string, serverData: string): void {
        if (!serverData) {
            return
        }
        if (serverData.length === 0) {
            return
        }
        let c: string = clientData, s: string = serverData;
        if ((c[0] + c[1]) != s) {
            debugger;
            Logger.logDev(`xWays reveal to symbol ${c} is not same from server: ${s}`)
        }
        if (c.length > 2 && this.wildMSymbols.indexOf(s) < 0) {
            debugger;
            Logger.logDev(`xWays reveal to symbol ${c} is not transformed`);
        }
    }

    private checkAllWinPositions(clientData: boolean[][], serverData: boolean[][]): void {

        if (!serverData && this.isNextRespin) {
            Logger.logDev("no win data")
        }

        if (serverData.length === 0) {
            return
        }
        let c: boolean[][] = clientData.concat(), s: boolean[][] = serverData.concat();
        for (let i: number = 0; i < 6; i++) {
            const a: boolean[] = c[i].splice(0, (c[i].length - s[i].length));
            if (a.indexOf(true) > -1) {
                debugger;
                Logger.logDev(`wins is not the same on reel ${i}`)
            }
            if (c[i].join() != s[i].join()) {
                debugger;
                Logger.logDev(`wins is not the same on reel ${i}`)
            }
        }
    }

    private isWildMidSymbol(symName: string): boolean {
        if (this.isNormal) {
            return false;
        }

        if (!TheCryptHelper.isCollectiveSymbol(symName)) {
            return false;
        }

        if (symName.indexOf("_W") > 0) {
            return true;
        }

        if (parseInt(symName[1]) > 1) {
            return this.wildMSymbols.indexOf(symName) > -1;
        }
        return false;
    }

    private parseNearWinOnRestore(prevScatters: number[], wasFeatureBuy: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!this._isRestore) {
            return nearWinReels;
        }
        if (!this.isNextRespin) {
            return nearWinReels;
        }

        if (this.isLuckyDraw || wasFeatureBuy) {
            return nearWinReels;
        }

        if (TheCryptHelper.sum(prevScatters) >= 2) {
            this.reels.forEach((syms: string[], i: number) => {
                if (prevScatters[i] >= 2) {
                    nearWinReels[i] = false;
                } else {
                    nearWinReels[i] = syms.indexOf("X") > -1;
                }
            });
        }

        return nearWinReels;
    }

    private parseNearWin(prevScatters: number[], newScatters: number[], wasFeatureBuy: boolean, isNormal: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!isNormal) {
            return nearWinReels;
        }

        let totalScatterNum: number = TheCryptHelper.sum(prevScatters),
            hasTwoScatters: boolean = totalScatterNum >= 2;

        if (this.isLuckyDraw) {
            newScatters.forEach((num: number, i: number) => {
                nearWinReels[i] = (totalScatterNum >= 3);
                totalScatterNum += num;
            });

            return nearWinReels;
        }

        if (wasFeatureBuy) {
            let type = 3;

            if (this._buyFeatureName == "FREESPIN_4_SCATTERS"){
                type = 4;
            }
            else if (this._buyFeatureName == "FREESPIN_5_SCATTERS"){
                type = 5;
            }

            newScatters.forEach((num: number, i: number) => {
                nearWinReels[i] = (totalScatterNum >= type) && (totalScatterNum < (type + 1));
                totalScatterNum += num;
            });

            return nearWinReels;
        }

        if (hasTwoScatters) {
            this.reels.forEach((syms: string[], i: number) => {
                if (prevScatters[i] >= 2) {
                    nearWinReels[i] = false;
                } else {
                    nearWinReels[i] = true;
                }
            });
        } else {
            newScatters.forEach((num: number, i: number) => {
                totalScatterNum += (num - prevScatters[i]);
                nearWinReels[i] = hasTwoScatters;
                hasTwoScatters = (totalScatterNum >= 2);
            });
        }
        return nearWinReels;
    }

    private parseScatterNumberOnReels(reels: string[][]): number[] {
        const scatterNumberOnReels: number[] = [];
        reels.forEach((syms: string[], i: number) => {
            let numberOfScatter: number = 0;

            syms.forEach((sym: string) => {
                numberOfScatter += (sym === "S" ? 1 : 0);
            });
            scatterNumberOnReels.push(numberOfScatter);
        });

        return scatterNumberOnReels;
    }

    private parseRestoreReelData(reels: string[][]): string[][] {
        let restoreReels: string[][] = [];
        reels.forEach((reel: string[], i: number) => {
            let hasWild: boolean = reel.indexOf("W") > -1;
            if (hasWild && (reel[2] === "W" && reel[3] === "W")) {
                restoreReels.push(["Y", "Y", "Y", "Y", "Y", "FW"]);
            } else {
                restoreReels.push(reel.concat());
            }
        });
        return restoreReels;
    }

    private parseReelData(reels: string[][], reelSizes: number[]): ISymbolData[][] {
        const reelsData: ISymbolData[][] = [];
        this.wildOnReel = ArrayHelper.initArrayWithValues(6, () => false);
        reels.forEach((reel: string[], i: number) => {
            const reelData: ISymbolData[] = [],
                symSize: number = this._isRestore ? (reelSizes[i] - 4 + 1) : 1;
            reel.forEach((symName: string, j: number) => {
                reelData.push({
                    symName: symName,
                    reelSize: reelSizes[i],
                    symSize: symSize,
                    id: j,
                    reelId: i
                });
                if (symName === "M") {
                    this.mysterySymbolPositions.push(i);
                }
            });
            let hasWild: boolean = reel.indexOf("W") > -1;
            if (hasWild) {
                hasWild = !(reel[2] === "W" && reel[3] === "W");
            }
            this.wildOnReel[i] = hasWild;
            reelsData.push(reelData);
        });
        return reelsData;
    }

    private parseFillUpReelData(reelsData: ISymbolData[][], reelSizes: number[]): ISymbolData[][] {
        const newReelsData: ISymbolData[][] = [];
        reelsData.forEach((reelData: ISymbolData[], i: number) => {
            const newReelData: ISymbolData[] = [],
                symSize: number = (reelSizes[i] - 4 + 1);
            reelData.forEach((data: ISymbolData, j: number) => {
                newReelData.push({
                    symName: data.symName,
                    reelSize: reelSizes[i],
                    symSize: symSize,
                    id: j,
                    reelId: i
                });
            });
            newReelsData.push(newReelData);
        });
        return newReelsData;
    }

    private getGameAreaSize(reels: string[][]): number[] {
        let defaultSize: number[] = [6, 6, 6, 6, 6, 6];
        reels.forEach((reel: string[], i: number) => {
            reel.forEach((sym: string, j: number) => {
                if (sym === "Y") {
                    defaultSize[i]--;
                }
            });
        });
        return defaultSize;
    }

    private getWildMultipliers(): number[] {
        let defaultSize: number[] = [0, 0, 0, 0, 0, 0];
        this.wildOnReel.forEach((hasWild: boolean, i: number) => {
            if (hasWild) {
                defaultSize[i] = 6 - this.reels[i].indexOf("W");
            }
        });
        return defaultSize;
    }

    private getMysterySymbolSize(beforeRevealSize: number[], afterRevealSize: number[]): number[] {
        let defaultSize: number[] = [0, 0, 0, 0, 0, 0];
        if (this.mysterySymbolPositions.length > 0) {
            afterRevealSize.forEach((size: number, i: number) => {
                if (size > beforeRevealSize[i]) {
                    defaultSize[i] = size - beforeRevealSize[i] + 1;
                }
            });
        }
        return defaultSize;
    }

    private getMysterySymbolRevealed(reels: string[][], evaluatedArea: string[][]): string {
        if (this.mysterySymbolPositions.length <= 0) {
            return "";
        }
        const reelId: number = this.mysterySymbolPositions[0],
            toSym: string = evaluatedArea[reelId][reels[reelId].indexOf("M")];
        return `${toSym}${this.wildMSymbols.indexOf(toSym) > -1 ? "_W" : ""}`;
    }

    private getSymbolPositionYs(reels: string[][], reelSizes: number[]): number[][] {
        const symbolPositions: number[][] = []
        reels.forEach((reel: string[], i: number) => {
            const symHeight: number = TheCryptGameConfig.reelHeight / reelSizes[i],
                posY: number[] = [];
            let toY: number = 0;
            reel.forEach((symName: string, j: number) => {
                if (symName != "Y") {
                    posY.push(toY + symHeight * 0.5);
                    toY += symHeight;
                } else {
                    posY.push(-200);
                }
            });
            symbolPositions.push(posY);
        });
        return symbolPositions;
    }

    private parseAllWinPositions(reels: string[][], betWayWinData: IBetWayWinData[]): boolean[][] {
        const winPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => false);
        });
        const allWinPositionSymbols: string[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => "");
        });
        this.maxWinReelId = -1;
        betWayWinData.forEach((betWayWin: IBetWayWinData) => {
            const winSym: string = betWayWin.symbol;
            this.maxWinReelId = Math.max(this.maxWinReelId, betWayWin.length);
            let reelWinPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
                return ArrayHelper.initArrayWithValues(6, () => false);
            });

            reels.forEach((reel: string[], i: number) => {
                if (i <= betWayWin.length) {
                    reel.forEach((symName: string, j: number) => {
                        if (symName === winSym || TheCryptHelper.isWildSymbol(symName) || this.isWildMidSymbol(symName)) {
                            winPositions[i][j] = true;
                            allWinPositionSymbols[i][j] = symName;
                            reelWinPositions[i][j] = true;
                        }
                    });
                }
            });
            betWayWin.reelWinPositions = reelWinPositions;
        });
        this.allWinPositionSymbols = allWinPositionSymbols;
        return winPositions;
    }

    private parseMysterySymbolPotentialWin(reels: string[][]): number[][][] {
        let potentialSym: string[] = [], endPos: number[] = [], fullWilds: boolean[] = [false],
            firstMOnReel: number = this.mysterySymbolPositions[0],
            lines: number[][][] = [];
        reels[0].forEach((sym: string) => {
            if (!TheCryptHelper.isInvisibleSym(sym) && potentialSym.indexOf(sym) < 0) {
                potentialSym.push(sym);
                endPos.push(0);
            }
        });

        for (let i: number = 1; i < 6; i++) {
            let m: number = potentialSym.length - 1;
            const hasXWaysSymbol: boolean = reels[i].indexOf("M") > -1,
                hasWildSymbol: boolean = reels[i].indexOf("W") > -1;
            fullWilds.push(reels[i][2] === "W" && reels[i][3] === "W");
            while (m > -1) {
                const hasPotentialSym: boolean = reels[i].indexOf(potentialSym[m]) > -1;
                if ((hasPotentialSym || hasXWaysSymbol || hasWildSymbol || fullWilds[i]) && (endPos[m] === (i - 1))) {
                    endPos[m]++;
                } else if (i >= 2 && endPos[m] < 2) {
                    potentialSym.splice(m, 1);
                    endPos.splice(m, 1);
                }
                m--;
            }
        }

        let n: number = endPos.length - 1;
        while (n > -1) {
            if (endPos[n] < 2 || endPos[n] < firstMOnReel) {
                potentialSym.splice(n, 1);
                endPos.splice(n, 1);
            }
            n--
        }

        if (potentialSym.length === 0) {
            return lines;
        }

        lines = ArrayHelper.initArrayWithValues(potentialSym.length, () => []);
        potentialSym.forEach((potentialSymName: string, symId: number) => {
            for (let s: number = 0; s <= endPos[symId]; s++) {
                reels[s].forEach((symbol: string, t: number) => {
                    if ((symbol === potentialSymName || symbol === "M" || TheCryptHelper.isWildSymbol(symbol) || this.isWildMidSymbol(symbol))) {
                        lines[symId].push([s, t]);
                    }

                });
            }
        });
        return lines;
    }

    private addWildOrMultiplier(reelsData: ISymbolData[][], M1NextMultiplier: number): void {
        const hasM1Multiplier: boolean = M1NextMultiplier > 1;

        reelsData.forEach((reelData: ISymbolData[]) => {
            reelData.forEach((data: ISymbolData) => {
                if (hasM1Multiplier && data.symName === "M1") {
                    data.M1Multiplier = M1NextMultiplier;
                }
                if (this.isWildMidSymbol(data.symName)) {
                    data.isWild = true
                }
            });
        });
    }

    private parseSideBarProgress(sideReel: [number, number]): number[] {
        const progresses: number[] = ArrayHelper.initArrayWithValues(6, () => -1),
            completedLevel: number = Math.min(Math.floor(sideReel[0] / TheCryptGameConfig.MSymbolCollectorLevels - 1), 5),
            unCompletedLevel: number = completedLevel + 1;

        this.nextWildMSymbols = (completedLevel > -1 ? ArrayHelper.initArrayWithValues(unCompletedLevel, (i: number) => {
            progresses[i] = TheCryptGameConfig.MSymbolCollectorLevels;
            return `M${6 - i}`;
        }) : []);

        if (unCompletedLevel <= 5) {
            progresses[unCompletedLevel] = sideReel[0] % TheCryptGameConfig.MSymbolCollectorLevels;
        }
        const currentProgress: number = sideReel[1] % TheCryptGameConfig.M1CollectorLevels;
        //progresses[5] = ((currentProgress === 0 && sideReel[1] > 0) ? TheCryptGameConfig.M1CollectorLevels : currentProgress);
        progresses[5] = sideReel[1];
        return progresses;
    }

    private parseM1MultiplierPositions(reels: string[][], multiplier: number): boolean[][] {
        if (multiplier === 1) {
            return []
        }

        const M1MultiplierPositions: boolean[][] = TheCryptHelper.createDefaultSixBySixBooleanArray();
        reels.forEach((reel: string[], i: number) => {
            reel.forEach((symName: string, j: number) => {
                if (symName === "M1") {
                    M1MultiplierPositions[i][j] = true;
                }
            });
        });

        return M1MultiplierPositions;
    }

    private parsePatchWildPositions(reels: string[][], sideReel: [number, number]): boolean[][] {
        const wildMidSymIndex: number = sideReel[0] / 4;
        if (wildMidSymIndex === 0) {
            return [];
        }

        if (!Number.isInteger(wildMidSymIndex)) {
            return [];
        }

        const patchWildPositions: boolean[][] = TheCryptHelper.createDefaultSixBySixBooleanArray();
        reels.forEach((reel: string[], i: number) => {
            reel.forEach((symName: string, j: number) => {
                if (this.isWildMidSymbol(symName)) {
                    patchWildPositions[i][j] = true;
                }
            });

        });
        return patchWildPositions;
    }

    private parseCollectorData(data: ITheCryptInitData, isNormal: boolean, isRespin: boolean = false): void {
        this.M1MultiplierPositions = [];
        this.patchWildPositions = [];
        this.sideBarProgress = this.parseSideBarProgress(data.dragonSideReel);
        if (!isNormal) {
            this.M1MultiplierPositions = this.parseM1MultiplierPositions(data.evaluatedArea, data.m1NextMultiplier);
            this.patchWildPositions = this.parsePatchWildPositions(data.evaluatedArea, data.dragonSideReel);
            this.addWildOrMultiplier(this.reelsData, data.m1NextMultiplier);
            if (isRespin) {
                this.addWildOrMultiplier(this.reelsFillUpData, data.m1NextMultiplier);
            }
        }
    }

    protected onInit(data: ITheCryptInitData): void {
        super.onInit(data);
        this.mysterySymbolPositions = [];
        this.brokeTheBank = false;
        this._isRestore = data.isRestoreState;
        this._isBigWin = false;
        this.hasMeterUpgrade = false;
        this._prevTotalWinBigWin = 0;
        this.boostedBet = (data.enhancedBet || (data.nextPlayerInteraction?.featureName != undefined && data.nextPlayerInteraction.featureName === TheCrypt.boostedName));
        this.gameAreaSize = this.getGameAreaSize(data.reels);
        this.reels = TheCryptHelper.copyArray(data.reels);
        if (this._isRestore) {
            this.reels = this.parseRestoreReelData(this.reels);
        }
        this.reelsData = this.parseReelData(this.reels, this.gameAreaSize);

        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.wasFeatureBuy = data.wasFeatureBuy;
        this.afterRevealGameAreaSize = data.gameAreaSize;
        this.freespinTriggeredThisSpin = (TheCryptHelper.isNormal(data.mode) && !TheCryptHelper.isNormal(data.nextMode));
        this.freespinsLeft = data.freespinsLeft;
        this.xNudgeMultiplier = this.getWildMultipliers();
        this.symbolPositionYs = this.getSymbolPositionYs(data.reels, data.gameAreaSize);
        this.symbolPositionYsAfterReveal = this.getSymbolPositionYs(data.reels, data.gameAreaSize);
        this.evaluatedArea = [];
        this.numberOfScattersOnReelPrev = ArrayHelper.initArrayWithValues(6, () => 0);
        this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels);
        this.sideBarProgress = this.parseSideBarProgress(data.dragonSideReel);
        this.wildMSymbols = this.nextWildMSymbols.concat();
        this.m1CurrentMultiplier = data.m1NextMultiplier;
        this.addWildOrMultiplier(this.reelsData, data.m1NextMultiplier);
        this.nearWinReels = this.parseNearWinOnRestore(this.numberOfScattersOnReel, data.wasFeatureBuy);
        this.maxWinReelId = -1;
        if (this._isRestore && TheCryptHelper.isRespin(data.nextMode)) {
            this.numberOfScattersOnReelPrev = this.numberOfScattersOnReel.concat();
        }
        if (TheCryptHelper.isRespin(data.nextMode)) {
            this.gameAreaSize = data.gameAreaSize;
        } else {
            this.gameAreaSize = TheCryptGameConfig.defaultGameAreaSize;
        }
    }

    public onGame(data: ITheCryptGameData): void {
        super.onGame(data);
        this.wildMSymbols = data.mode[0] === "N"?[]:this.nextWildMSymbols.concat();
        const isRespin: boolean = TheCryptHelper.isRespin(data.mode);
        const isNextRespin: boolean = TheCryptHelper.isRespin(data.nextMode);
        if (data.mode[0] === "N") {
            this.boostedBet = data.enhancedBet;
        }
        this.hasMeterUpgrade = false;
        this.mysterySymbolPositions = [];
        this._prevTotalWinBigWin = isRespin ? this._prevTotalWinBigWin : 0;
        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.hasNoAvalancheWin = (data.thisSpinWinning === 0);
        const isNormal: boolean = this.isNormal;
        this.brokeTheBank = data.brokeTheBank;
        this.wasFeatureBuy = data.wasFeatureBuy;
        this.freespinTriggeredThisSpin = (TheCryptHelper.isNormal(data.mode) && !TheCryptHelper.isNormal(data.nextMode));
        this.reels = TheCryptHelper.copyArray(data.reels);
        if (!this.isRestore) {
            this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels);
            this.nearWinReels = this.parseNearWin(this.numberOfScattersOnReelPrev, this.numberOfScattersOnReel, data.wasFeatureBuy, isNormal);
        }
        this._isRestore = false;

        this.reelsData = this.parseReelData(this.reels, this.gameAreaSize);
        this.reelsFillUpData = this.parseFillUpReelData(this.reelsData, this.gameAreaSize);
        this.evaluatedArea = TheCryptHelper.copyArray(data.evaluatedArea);
        this.parseCollectorData(data, isNormal, isRespin);

        this.numberOfScattersOnReelPrev = isNextRespin ? this.parseScatterNumberOnReels(data.reels) : [0, 0, 0, 0, 0, 0];
        this.xNudgeMultiplier = this.getWildMultipliers();

        this.mysterySymbolSize = this.getMysterySymbolSize(this.gameAreaSize, data.gameAreaSize);
        this.mysterySymbolRevealed = this.getMysterySymbolRevealed(data.reels, data.evaluatedArea);

        this.symbolPositionYs = this.getSymbolPositionYs(data.reels, this.gameAreaSize);
        this.symbolPositionYsAfterReveal = this.getSymbolPositionYs(data.evaluatedArea, data.gameAreaSize);
        this.afterRevealGameAreaSize = data.gameAreaSize;

        this.allWinPositionSymbols = [];
        this.allWinPositions = this.parseAllWinPositions(data.evaluatedArea, data.betWayWins);
        this.mysterySymbolPotentialWin = this.mysterySymbolRevealed ? this.parseMysterySymbolPotentialWin(data.reels) : [];
        this.winData = data.betWayWins;
        this.accumulatedRoundWin = data.accumulatedRoundWin;
        this.avalancheRoundWin = data.totalSpinWinnings;
        this.winRatio = MathHelper.roundToDecimals(data.totalSpinWinnings / data.playedBetValue, 1);
        this.currentWinRatio = MathHelper.roundToDecimals(data.totalSpinWinnings / data.playedBetValue, 1);
        this.avalancheWinRatio = MathHelper.roundToDecimals(data.thisSpinWinning / data.playedBetValue, 1);
        this.prevBigWinLevel = TheCryptWinConfig.getBigWinLevel(MathHelper.roundToDecimals(this._prevTotalWinBigWin / data.playedBetValue, 1));
        this.isWin = !isNextRespin && isRespin;
        this._isBigWin = !isNextRespin && TheCryptHelper.isBigWin(data.totalSpinWinnings, this.gameData?.playedBetValue);
        this.freespinsLeft = data.freespinsLeft;
        this.m1CurrentMultiplier = data.m1CurrentMultiplier;

        if (NolimitConfig.isDevMode) {
            this.checkXNudgeMultiplier(this.xNudgeMultiplier, data.xNudgeMultiplier, this.reels);
            this.checkXWayRevealedSymbol(this.mysterySymbolRevealed, data.mysterySymbolRevealed);
            this.checkAllWinPositions(this.allWinPositions, data.position);
        }

        if (!isRespin && isNextRespin) {
            this.allWinPositions.forEach((winPositions: boolean[], reelId: number) => {
                if (data.reels[reelId].indexOf("W") < 0) {
                    winPositions.forEach((win: boolean, symId: number) => {
                        if (win) {
                            this.reelsData[reelId][symId].hasHighlight = true;
                        }
                    });
                }
            });
        }

        if (isNextRespin) {
            this.gameAreaSize = data.gameAreaSize;
        } else {
            this.gameAreaSize = TheCryptGameConfig.defaultGameAreaSize;
        }
    }

    public get isNormal(): boolean {
        return TheCryptHelper.isNormal(this.mode);
    }

    public get isNextNormal(): boolean {
        return TheCryptHelper.isNormal(this.nextMode);
    }

    public get isNextRespin(): boolean {
        return TheCryptHelper.isRespin(this.nextMode);
    }

    public get isRestore(): boolean {
        return this._isRestore;
    }

    public get buyFeatureName(): string {
        return this._buyFeatureName;
    }

    public get isLuckyDraw(): boolean {
        return this._buyFeatureName === "LUCKY_DRAW";
    }

    public get hasNudge(): boolean[] {
        let nudgeReel: boolean[] = ArrayHelper.initArrayWithValues(6, (i: number) => this.wildOnReel[i]);
        this.reels.forEach((reel: string[], j: number) => {
            if (nudgeReel[j]) {
                nudgeReel[j] = ((reel[2] === "W" && reel[3] === "W") ? false : nudgeReel[j]);
            }
        });
        return nudgeReel;
    }

    public get isBigWin(): boolean {
        return this._isBigWin;
    }

    public get hasXWaysSymbolThisAvalanche(): boolean {
        return this.mysterySymbolPositions.length > 0;
    }
}